"use client";

import { motion } from "framer-motion";

const SectionHeader = ({ title, text }: { title: string; text?: string }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      className="container !px-4 py-10 flex flex-col items-center"
    >
      <h4 className="font-caveat text-2xl font-semibold mb-5">{title}</h4>
      <h1 className="text-2xl md:text-4xl !leading-[50px] text-center font-semibold">
        {text}
      </h1>
    </motion.div>
  );
};

export default SectionHeader;
